// extracted by mini-css-extract-plugin
export var leftAlign = "_f-2";
export var popper = "_f-0";
export var subtitle = "_f-1";